import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/lems-v1/images/close-black-icon.svg'
import _imports_1 from '@/assets/lems-v1/images/download-hover.svg'


const _hoisted_1 = {
  class: "modal fade",
  id: "fileDownloadPop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog download-file-pop",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "download-file-pop-content" }
const _hoisted_5 = { class: "download-type-radio" }
const _hoisted_6 = { class: "file-download--radio" }
const _hoisted_7 = {
  for: "radio1",
  class: "css-label"
}
const _hoisted_8 = { class: "file-download--radio" }
const _hoisted_9 = {
  for: "radio2",
  class: "css-label"
}
const _hoisted_10 = { class: "download-file-pop-btn" }
const _hoisted_11 = {
  class: "v1-button-outline",
  id: "downloadButton"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("button", {
          type: "button",
          class: "close",
          "data-bs-dismiss": "modal",
          "aria-label": "Close"
        }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: ""
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("i", null, [
            _createElementVNode("img", {
              src: _imports_1,
              alt: ""
            })
          ], -1)),
          _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Lenvio discuss with Binod.mp3", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("input", {
                type: "radio",
                name: "radiog_download",
                id: "radio1",
                checked: "true",
                class: "css-checkbox"
              }, null, -1)),
              _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.constants.LOCALE_SYSTEM_LABEL), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[1] || (_cache[1] = _createElementVNode("input", {
                type: "radio",
                name: "radiog_download",
                id: "radio2",
                class: "css-checkbox"
              }, null, -1)),
              _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.constants.CLOUD_LABEL), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", _hoisted_11, _toDisplayString(_ctx.constants.DOWNLOAD_BUTTON), 1)
          ])
        ])
      ])
    ])
  ]))
}